export default __webpack_public_path__ + "static/media/video-icon.41be7a01.svg";